import {
  fetchRouteInformation,
  getFilterData,
  getRouteData,
} from "../network/Network";
import {
  getDataWithExpiry,
  isRouteCacheValid,
  setDataWithExpiry,
} from "../util/CacheManager";
import { ROUTE_DATA_CACHE_KEY } from "../util/LocalStorageKey";
import { DEFAULT_CAPABILITIES } from "../util/Constants";

export const OutboundOverviewAMZLReducer = (state, action) => {
  switch (action.type) {
    case "LOAD_VIEW":
      //Note: currently stationConfig will be null for ARv2
      const {
        dispatcher,
        filterDispatcher,
        capability,
        xptNodes,
        stationConfig,
      } = action.data;

      if (
        DEFAULT_CAPABILITIES.includes(capability) &&
        isRouteCacheValid(xptNodes)
      ) {
        const { cachedData, lastUpdated } =
          getDataWithExpiry(ROUTE_DATA_CACHE_KEY);
        dispatcher({
          type: "RECEIVE_DATA",
          data: getRouteData(
            cachedData.response.routes,
            capability,
            stationConfig,
          ),
          lastUpdated: lastUpdated,
        });
        filterDispatcher({
          type: "RECEIVE_FILTER_DATA",
          data: getFilterData(cachedData.response.routes, stationConfig),
        });
        return state;
      }
      fetchRouteInformation(action.data);
      return state;
    case "RECEIVE_DATA":
      return {
        ...state,
        ...action.data,
        routesNotAssignedCount: action.routesNotAssignedCount,
        lastUpdated: action.lastUpdated,
      };
    case "UPDATE_ROUTE_DATA_CACHE": {
      setDataWithExpiry(ROUTE_DATA_CACHE_KEY, action.data, action.lastUpdated);
      return state;
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/components/outboundAmzl/reducers/OutboundOverviewAMZLReducer.js